import type { Inline } from "../../lib/release-notes";

/** Renders the parser's inline runs: text, code, strong, em, links. */
export function Inlines({ parts }: { parts: Inline[] }) {
  return (
    <>
      {parts.map((p, i) => {
        switch (p.kind) {
          case "code":
            return (
              <code key={i} className="rounded bg-canvas px-1 font-mono text-[0.9em] [overflow-wrap:anywhere]">
                {p.text}
              </code>
            );
          case "strong":
            return <strong key={i}>{p.text}</strong>;
          case "em":
            return <em key={i}>{p.text}</em>;
          case "link":
            return (
              <a key={i} href={p.href} rel="noreferrer">
                {p.text}
              </a>
            );
          default:
            return <span key={i}>{p.text}</span>;
        }
      })}
    </>
  );
}
